import PropTypes from 'prop-types';
import { parse as parseQs } from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Auth from '../../services/auth';
import { login } from '../../store/ducks/auth';
import Launcher from './components/Launcher';

export class Home extends React.Component {
  state = {
    init: false,
    auth: false,
  };

  async componentDidMount() {
    const { location, dispatch } = this.props;

    const params = location ? parseQs(location.hash) : {};
    const auth = await Auth.setToken(params.id_token);

    this.setState(() => ({ auth, init: true }));
    this.clearHash();

    if (auth) {
      dispatch(login(auth));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  clearHash = () => {
    window.history.replaceState(
      '',
      document.title,
      window.location.href.replace(/#.*$/, '')
    );
  };

  render() {
    const { init, auth } = this.state;

    if (init) {
      if (auth) {
        return (<Launcher />);
      }

      return (<Redirect to="/logout" />);
    }

    return (
      <h1>
        <span id="title">Loading...</span>
      </h1>
    );
  }
}

Home.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(Home);
